import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const Footer = () => {
  const year = new Date().getFullYear();
  const location = useLocation();
  const navigate = useNavigate();

  const goTo = (id) => {
    if (location.pathname !== "/") {
      navigate(`/#${id}`);
      return;
    }
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-ink text-white">
      <div className="site-wrap flex flex-col gap-8 border-t border-white/10 py-8 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm tracking-wide">LC</p>
        <div className="flex flex-wrap gap-6 text-[13px] text-white/55">
          {[
            ["About Me", "about"],
            ["Portfolio", "projects"],
            ["Contact", "contact"],
          ].map(([label, id]) => (
            <button key={id} type="button" onClick={() => goTo(id)} className="hover:text-white">
              {label}
            </button>
          ))}
          <a href="https://instagram.com/lissacodes" target="_blank" rel="noopener noreferrer" className="hover:text-white">
            Instagram
          </a>
          <a href="https://github.com/lisss44" target="_blank" rel="noopener noreferrer" className="hover:text-white">
            GitHub
          </a>
        </div>
        <p className="font-mono text-[11px] text-white/35">© {year}</p>
      </div>
    </footer>
  );
};

export default Footer;
